<!-- ? Input -->
<div class="w-full relative flex items-center">
  <span class="absolute right-4 flex items-center text-gray-500">
    <span class="icon search-regular text-base"></span>
  </span>
  <input
    type="text"
    class="w-full pr-10"
    placeholder="جست‌و‌جو در بیش از 1.000.000 کتاب، کاربر و نویسنده"
    [formControl]="termControl"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (focus)="openPanel()"
    (keydown.enter)="navigateToSearchPage(searchTabEnum.books); closePanel()"
    id="searchInput"
    autocomplete="off" />
  @if (termControl.valid) {
    <p class="absolute left-3 cursor-pointer text-gray-500" (click)="clearSearch()">
      <span class="icon dismiss-regular text-xs text-gray-500"></span>
    </p>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="panelOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="closePanel()"
  (detach)="closePanel()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
  ]">
  @if (termControl?.value?.length > 1 || searchHistory.length > 0) {
    <div [style.width.px]="origin.elementRef.nativeElement.offsetWidth" @fade class="custom-panel w-full flex flex-wrap absolute z-20 rounded-b-md bg-gray-50 dark:bg-gray-800 shadow-sm">

      <!-- ? History -->
      @if (!termControl.value) {
        <div class="w-full rounded-md bg-gray-50 dark:bg-gray-800 shadow-sm border border-gray-200 dark:border-gray-700">
          <div class="w-full px-4 pt-2 flex flex-wrap justify-between">
            <span class="text-sm text-gray-400">جست‌و‌جوهای اخیر</span>
          </div>

          <div class="w-full p-2 flex flex-wrap justify-between">
            @for (history of searchHistory | slice: 0 : 7; track $index) {
              <div class="cursor-pointer min-h-8 rounded-md w-full flex flex-wrap justify-start items-center my-1">
                <div class="w-11/12 flex items-center px-2 h-full" (click)="loadHistory(history)">
                  <a class="text-sm text-gray-800" [routerLink]="[routes.search]" [queryParams]="{ q: history, category: searchTabEnum.books }">
                    {{ history }}
                  </a>
                </div>
                <div class="w-1/12 px-2 h-full flex justify-end items-center" (click)="removeHistoryItem($index)">
                  <span class="icon dismiss-regular text-gray-500 text-xs"></span>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- ? Loading -->
      @if (loading) {
        <div class="w-full">
          @for (item of [1, 1, 1]; track $index) {
            <div class="px-4 py-1 flex justify-start items-start">
              <ngx-skeleton-loader [theme]="{ height: '48px', width: '30px' }"></ngx-skeleton-loader>
              <div class="w-11/12 flex flex-wrap px-4">
                <div class="w-full" style="max-height: 20px">
                  <ngx-skeleton-loader [theme]="{ height: '12px', width: '100px' }"> </ngx-skeleton-loader>
                </div>
                <div class="w-full" style="max-height: 12px">
                  <ngx-skeleton-loader [theme]="{ height: '8px', width: '160px' }"> </ngx-skeleton-loader>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- ? Suggestion Result -->
      @if (!loading) {
        <div class="w-full overflow-y-auto hide-scrollbar max-h-[calc(100dvh-7rem)]">

          <!-- ? Books -->
          @if (result?.books?.items && result?.books?.items?.length > 0) {
            <div class="flex flex-wrap">
              <div
                class="w-full h-12 px-4 flex flex-wrap items-center justify-between cursor-pointer bg-gray-100 dark:bg-gray-700"
                (click)="navigateToSearchPage(searchTabEnum.books); $event.stopPropagation()">
                <p class="text-sm text-gray-600">
                  کتاب
                  <span class="text-sm mr-1 text-gray-500">({{ result?.books?.totalCount | number }})</span>
                </p>
                <p class="text-xs text-blue-500">نتایج بیشتر</p>
              </div>

              @for (book of $any(result?.books?.items | slice: 0 : 5); track $index) {
                <div class="w-full px-4 flex my-2 items-center cursor-pointer text-gray-600">
                  <a class="cursor-pointer" [routerLink]="[routes.book, book.id]" (click)="closePanel()">
                    <img
                      loading="lazy"
                      class="w-[34px] h-[51px] object-cover rounded-md"
                      onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_book.svg'"
                      [src]="book.id | image: imageType.book : book?.hasPhoto"
                      [alt]="book?.name" />
                  </a>
                  <div class="relative px-4 grow flex flex-wrap">
                    <a class="cursor-pointer" [routerLink]="[routes.book, book.id]" (click)="closePanel()">
                      <span class="text-sm text-gray-800" [innerHTML]="book?.name | highlight: termControl.value!"></span>

                      <ng-container *ngIf="book.seriesNumber">
                        <span class="mr-3 seri-number"> جلد {{ book.seriesNumber }} </span>
                      </ng-container>
                    </a>
                    <div class="w-full line-clamp-1">
                      @for (author of book?.authors | authorSort | slice: 0 : 1; track $index) {
                        <a class="cursor-pointer text-sm text-gray-500" [routerLink]="[routes.profile, author.id]" (click)="closePanel()">
                          {{ (author | authorType)?.name }}
                        </a>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          <!-- ? Authors -->

          @if (result?.authors?.items && result?.authors?.items?.length > 0) {
            <div class="flex flex-wrap">
              <!-- ? Header Detail -->
              <div
                class="w-full h-12 px-4 flex flex-wrap items-center justify-between cursor-pointer bg-gray-100 dark:bg-gray-700"
                (click)="navigateToSearchPage(searchTabEnum.authors); $event.stopPropagation()">
                <p class="text-sm text-gray-600">
                  پدیدآور
                  <span class="text-sm mr-1 text-gray-500">({{ result?.authors?.totalCount | number }})</span>
                </p>
                <p class="text-xs text-blue-500">نتایج بیشتر</p>
              </div>

              <!-- ? Authors Result -->
              @for (author of $any(result?.authors?.items | slice: 0 : 3); track $index) {
                <div class="w-full px-4 flex my-2 items-center relative">
                  <div class="relative grow flex items-center">
                    <a class="cursor-pointer link text-gray-600 items-center flex" [routerLink]="[routes.profile, author.id]" (click)="closePanel()">
                      <!--! Wait For Services  -->
                      <img
                        loading="lazy"
                        class="avatar-sm"
                        width="32"
                        height="32"
                        onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
                        [src]="author.id | image: imageType.authorAvatar : author?.hasPhoto"
                        [alt]="author.firstName" />
                      <div class="w-full relative px-4 grow flex items-center">
                        <p class="text-sm text-gray-800" [innerHTML]="author.firstName | highlight: termControl?.value"></p>
                      </div>
                    </a>
                  </div>

                  <app-follow-btn class="h-8 md:h-10 w-28 min-w-28 max-w-28" [tabindex]="-1" [user]="author | followUserData" (Follow)="FollowClicked($event)"></app-follow-btn>
                </div>
              }
            </div>
          }

          <!-- to do: repeated code -->
          <!-- ? Users -->

          @if (result?.customers?.items && result?.customers?.items?.length > 0) {
            <div class="flex flex-wrap">
              <div
                class="w-full h-12 px-4 flex items-center flex-wrap justify-between cursor-pointer bg-gray-100 dark:bg-gray-700"
                (click)="navigateToSearchPage(searchTabEnum.users); $event.stopPropagation()">
                <p class="text-sm text-gray-600">
                  کاربر
                  <span class="text-sm mr-1 text-gray-500">({{ result?.customers?.totalCount | number }})</span>
                </p>
                <p class="text-xs text-blue-500">نتایج بیشتر</p>
              </div>

              @for (user of $any(result?.customers?.items | slice: 0 : 3); track $index) {
                <div class="w-full px-4 flex items-center my-2 relative">
                  <div class="relative grow flex items-center">
                    <a class="cursor-pointer text-gray-600 items-center flex" [routerLink]="[routes.profile, user.uniqeName]" (click)="closePanel()">
                      <img
                        loading="lazy"
                        class="avatar-sm"
                        width="32"
                        height="32"
                        onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
                        [src]="user.id | image: imageType.userAvatar : user?.hasPhoto"
                        [alt]="user.firstName" />
                      <div class="w-full relative px-4 grow flex items-center">
                        <p class="text-sm text-gray-800" [innerHTML]="user.firstName | highlight: termControl?.value"></p>
                      </div>
                    </a>
                  </div>

                  <app-follow-btn class="h-8 md:h-10 w-28 min-w-28 max-w-28" [tabindex]="-1" [user]="user | followUserData" (Follow)="FollowClicked($event)"></app-follow-btn>
                </div>
              }
            </div>
          }

          <!-- ? Publisher -->

          @if (result?.publishers?.items && result?.publishers?.items?.length > 0) {
            <div class="flex flex-wrap">
              <div
                class="w-full h-12 px-4 flex items-center flex-wrap justify-between cursor-pointer bg-gray-100 dark:bg-gray-700"
                (click)="navigateToSearchPage(searchTabEnum.publishers); $event.stopPropagation()">
                <p class="text-sm text-gray-600">
                  ناشر
                  <span class="text-sm mr-1 text-gray-500">({{ result?.publishers?.totalCount | number }})</span>
                </p>
                <p class="text-xs text-blue-500">نتایج بیشتر</p>
              </div>

              @for (publisher of $any(result?.publishers?.items | slice: 0 : 3); track $index) {
                <div class="w-full px-4 my-2 flex items-center relative">
                  <div class="relative grow flex items-center">
                    <a class="cursor-pointer text-gray-600 items-center flex" [routerLink]="[routes.profile, publisher.id]" [queryParams]="{ isPublisher: true }" (click)="closePanel()">
                      <!--! Wait For Services -->
                      <img
                        loading="lazy"
                        class="avatar-sm"
                        width="32"
                        height="32"
                        onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
                        [src]="publisher.id | image: imageType.publisherAvatar : publisher?.hasPhoto"
                        [alt]="publisher.title" />
                      <div class="w-full relative px-4 grow flex items-center">
                        <p class="text-sm text-gray-800" [innerHTML]="publisher.title | highlight: termControl?.value"></p>
                      </div>
                    </a>
                  </div>

                  <app-follow-btn class="h-8 md:h-10 w-28 min-w-28 max-w-28" [tabindex]="-1" [user]="publisher | followUserData" (Follow)="FollowClicked($event)"></app-follow-btn>
                </div>
              }
            </div>
          }

          <!-- ? Club -->
          @if (result?.clubs?.items && result?.clubs?.items?.length > 0) {
            <div class="flex flex-wrap">
              <div
                class="w-full h-12 px-4 flex items-center flex-wrap justify-between cursor-pointer bg-gray-100 dark:bg-gray-700"
                (click)="navigateToSearchPage(searchTabEnum.clubs); $event.stopPropagation()">
                <p class="text-sm text-gray-600">
                  باشگاه‌
                  <span class="text-sm mr-1 text-gray-500">({{ result?.clubs?.totalCount | number }})</span>
                </p>
                <p class="text-xs text-blue-500">نتایج بیشتر</p>
              </div>

              @for (club of $any(result?.clubs?.items | slice: 0 : 3); track $index) {
                <div class="w-full px-4 flex my-2 items-center relative">
                  <div class="w-full relative px-4 grow flex items-center">
                    <a class="cursor-pointer link text-gray-600 items-center flex" [routerLink]="[routes.club, club.id]" (click)="closePanel()">
                      <!--! Wait For Services -->
                      <img
                        loading="lazy"
                        class="avatar-sm"
                        width="32"
                        height="32"
                        onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
                        [src]="club.id | image: imageType.clubAvatar : club?.hasPhoto"
                        [alt]="club?.name" />

                      <div class="w-full relative px-4 grow flex items-center">
                        <p class="text-sm text-gray-800 cursor-pointer" [innerHTML]="club.name | highlight: termControl?.value"></p>
                      </div>
                    </a>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>
